var _ = require('lodash')
var forwardEl = '.incremental-scroll-forward'
var backEl = '.incremental-scroll-back'
var wrapperEl = '.scroll-wrapper'
var selectedEl = '.selected'
var isHorizontal = null

// methods
var scrollToSelected = null
var clickNext = null
var forwardFunction = null
var backFunction = null

export default {
    bind: function (el, binding, vnode) {
        var forwardFunction = binding.value.forward
        var backFunction = binding.value.back
        var speed = binding.value.speed ? binding.value.speed : 100
        isHorizontal = binding.value.is_horz ? binding.value.is_horz : false

        // If vertical scrolling resize the vertical thumbnail wrapper
        $(window).resize(function () {
            if (!isHorizontal) {
                parent = $(el).find(wrapperEl).parent().height()
                $(el).find(wrapperEl).height(parent)
            }
        })

        // Function to scroll to selected
        scrollToSelected = function (elem, is_horz) {
            var selected = $(elem).find(wrapperEl).find(selectedEl)
            var container = $(elem).find(wrapperEl)

            if (selected.length == 0) {
                return false
            }

            if (is_horz) {
                // Move left and right
                var scrollLeft = selected.offset().left - container.offset().left + container.scrollLeft()
                $(elem).find(wrapperEl).animate({'scrollLeft': scrollLeft}, speed)
            } else {
                // Move up and down
                var scrollTo = selected.offset().top - container.offset().top + container.scrollTop()
                $(elem).find(wrapperEl).animate({'scrollTop': scrollTo}, speed)
            }
        }

        // Function to scroll to selected
        // clickNext = function(e) {
        //     if (isHorizontal) {
        //         // left, right arrow will go to previous image
        //         if (e.keyCode == 39) {forwardFunction()}
        //         if (e.keyCode == 37) {backFunction()}
        //     } else {
        //         // up, down arrow will go to previous image
        //         if (e.keyCode == 40) {forwardFunction()}
        //         if (e.keyCode == 38) {backFunction()}
        //     }
        // }

        // button & keyboard event listeners
        $(el).find(forwardEl).off('click', forwardFunction)
        $(el).find(forwardEl).on('click', forwardFunction)

        $(el).find(backEl).off('click', backFunction)
        $(el).find(backEl).on('click', backFunction)
        // $('html').on('keyup', clickNext)

        // Scroll to selected element
        scrollToSelected(el, isHorizontal)
    },
    componentUpdated: function (el, binding) {
        isHorizontal = binding.value.is_horz ? binding.value.is_horz : false

        if (isHorizontal) {
            $(el).find(wrapperEl).height('initial')
        } else {
            parent = $(el).find(wrapperEl).parent().height()
            $(el).find(wrapperEl).height(parent)
        }

        // Scroll to selected element
        scrollToSelected(el, isHorizontal)
    },
    inserted: function (el, binding) {
        isHorizontal = binding.value.is_horz ? binding.value.is_horz : false

        if (isHorizontal) {
            $(el).find(wrapperEl).height('initial')
        } else {
            parent = $(el).find(wrapperEl).parent().height()
            $(el).find(wrapperEl).height(parent)
        }

        // Scroll to selected element
        scrollToSelected(el, isHorizontal)
    },
    update: function (el, binding) {
        var selected = binding.value.selected
        isHorizontal = binding.value.is_horz ? binding.value.is_horz : false

        // Scroll to selected element
        scrollToSelected(el, isHorizontal)
    }

}

